<mbs-sidepanel
  innerContentType="inner"
  side="right"
  [actionNames]="{ save: ('shared:buttons.saveChanges' | i18next), close: ('shared:buttons.close' | i18next) }"
  [disabledSave]="!isValidSidepanel()"
  [id]="sidePanelId"
  [isCreate]="false"
  [large]="true"
  [loadingData]="loadingData"
  [showDelete]="false"
  [showExpandedCross]="true">
  <div
    class="mbs-sidepanel_title"
    header-title>
    <div class="mbs-sidepanel_title-name">
      {{ 'shared:sidePanelOnlineAccess.title' | i18next }}
    </div>
  </div>

  <ng-container body>
    <mbs-alert
      [icon]="true"
      [type]="alertType.info">
      <span>{{ 'shared:sidePanelOnlineAccess.alertText1' | i18next }}</span>
      @if ('HelpMarketing' | can: 'read') {
        <span>{{ 'shared:sidePanelOnlineAccess.alertText2' | i18next }}</span>
        <a
          target="_blank"
          [helpLink]="'/organization/settings/online-access'">
          {{ 'shared:sidePanelOnlineAccess.alertLink' | i18next }}</a
        >
      }
      <span>{{ 'shared:sidePanelOnlineAccess.alertText3' | i18next }}</span>
      <a [href]="'mailto:' + ('shared:sidePanelOnlineAccess.alertEmail' | i18next)">
        {{ 'shared:sidePanelOnlineAccess.alertEmail' | i18next }}
      </a>
    </mbs-alert>

    <form [formGroup]="form">
      <section class="mbs-sidepanel_section">
        <div class="mbs-sidepanel_section-content">
          <div class="mbs-sidepanel_section-block">
            <mbs-form-group>
              <mbs-switcher
                formControlName="enableOnlineAccess"
                id="enableOnlineAccess"
                [label]="enableOnlineAccessLabel"></mbs-switcher>
              <div
                class="mt-2"
                formGroupName="optionsForm">
                <mbs-checkbox
                  class="ml-4 pl-3"
                  formControlName="enableBackup"
                  [label]="enableBackupLabel"></mbs-checkbox>
                @if (isConnectAvailable) {
                  <mbs-checkbox
                    class="ml-4 pl-3 mt-2"
                    formControlName="enableConnect"
                    [label]="enableConnectLabel"></mbs-checkbox>
                }
                @if ('AllowTicketingSubsystem' | can: 'read') {
                  <mbs-checkbox
                    class="ml-4 pl-3 mt-2"
                    formControlName="enableTickets"
                    [label]="enableTicketsLabel"></mbs-checkbox>
                }
              </div>
            </mbs-form-group>
          </div>
        </div>
      </section>
      <section
        class="mbs-sidepanel_section -bordered"
        formGroupName="optionsForm">
        <div class="mbs-sidepanel_section-content">
          <div class="mbs-sidepanel_section-block">
            <mbs-form-group>
              <mbs-input
                formControlName="alias"
                id="alias"
                [label]="aliasLabel"
                [placeholder]="'shared:sidePanelOnlineAccess.aliasPlaceholder' | i18next"
                (change)="handleAliasChange()"></mbs-input>
            </mbs-form-group>
            <mbs-form-group>
              <mbs-input
                formControlName="commonURL"
                id="commonURL"
                [appendButtons]="appendButtonsCommon"
                [label]="commonURLLabel"
                [readonly]="true"
                (buttonClick)="handleURLButton($event)"></mbs-input>
            </mbs-form-group>
          </div>
        </div>
      </section>
      @if ('CustomCertificatesBinding' | can: 'read') {
        <section class="mbs-sidepanel_section -bordered">
          <div class="mbs-sidepanel_section-content">
            <div class="mbs-sidepanel_section-block">
              <ng-container>
                <mbs-form-group>
                  <span class="row">
                    <span class="col fw-bold">{{ 'shared:sidePanelOnlineAccess.domainCustomization' | i18next }}</span>
                  </span>
                  <span class="row mt-2">
                    <span class="col">{{ 'shared:sidePanelOnlineAccess.youCanHaveDomain' | i18next }}</span>
                  </span>
                  <span class="row mt-1">
                    <span class="col"
                      ><strong>{{ 'shared:sidePanelOnlineAccess.domainExample' | i18next }}</strong></span
                    >
                  </span>
                </mbs-form-group>
                <mbs-button (click)="handleBindingRedirect()">
                  {{ 'shared:sidePanelOnlineAccess.bindingRedirect' | i18next }}
                </mbs-button>
              </ng-container>
            </div>
          </div>
        </section>
      }
    </form>
  </ng-container>
  <ng-template #enableOnlineAccessLabel>
    <span class="fw-bold">{{ 'shared:sidePanelOnlineAccess.allowOnlineAccess' | i18next }}</span>
  </ng-template>
  <ng-template #enableBackupLabel>
    {{ 'shared:sidePanelOnlineAccess.allowBackup' | i18next }}
  </ng-template>
  <ng-template #enableConnectLabel>
    {{ 'shared:sidePanelOnlineAccess.allowConnect' | i18next }}
  </ng-template>
  <ng-template #enableTicketsLabel>
    {{ 'shared:sidePanelOnlineAccess.allowTickets' | i18next }}
  </ng-template>
  <ng-template #aliasLabel>
    <span>{{ 'shared:sidePanelOnlineAccess.alias' | i18next }}</span>
    <span
      class="ico ico-info-circle ml-2 cursor-help text-info"
      container="body"
      [ngbTooltip]="'shared:sidePanelOnlineAccess.aliasText' | i18next"></span>
  </ng-template>
  <ng-template #commonURLLabel>
    <span class="row align-items-center">
      <span class="col fw-bold">{{ 'shared:sidePanelOnlineAccess.commonURL' | i18next }}</span>
    </span>
  </ng-template>
</mbs-sidepanel>
